import { render, staticRenderFns } from "./AdminClients.vue?vue&type=template&id=df18f172&scoped=true"
import script from "./AdminClients.vue?vue&type=script&lang=ts"
export * from "./AdminClients.vue?vue&type=script&lang=ts"
import style0 from "./AdminClients.vue?vue&type=style&index=0&id=df18f172&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df18f172",
  null
  
)

export default component.exports